import type { DepartmentOptionsObject } from "../../translation-keys/department-option-keys.js";

const FormDepartmentOptions: DepartmentOptionsObject = {
  "Accounting/Finance": "Buchhaltung/Finanzen",
  "Blood Bank": "Blutbank",
  "Clinical": "Klinisch",
  "Customer Service": "Kundenservice",
  "Document Control": "Dokumentenlenkung",
  "EHS": "EHS (Umwelt, Gesundheit und Sicherheit)",
  "Engineering": "Ingenieurwesen",
  "Executive (C-level or VP)": "Führungskraft (Geschäftsleitungsebene oder VP)",
  "Human Resources": "Personalverwaltung",
  "IT / Information Systems": "IT/Informationssysteme",
  "Laboratory": "Labor",
  "Manufacturing": "Fertigung",
  "Operations": "Betriebliche Abläufe",
  "Other": "Sonstiges",
  "Packaging": "Verpackungen",
  "Product Development": "Produktentwicklung",
  "Purchasing": "Einkauf",
  "Quality": "Qualität",
  "R&D": "F&E",
  "R&D QA": "F&E QS",
  "Regulatory": "Regulierungsangelegenheiten",
  "Sales / Marketing": "VERTRIEB/MARKETING",
  "Training": "Schulung",
  "Validation": "Validierung",
};

export default FormDepartmentOptions;